import { z } from 'zod';

import { MatchingRecord } from '@eluve/utils';

import { AppointmentFileTypesEnum } from './types';

export const AppointmentFileTypesLookup = {
  ADMIN_UPLOAD_AUDIO: 'ADMIN_UPLOAD_AUDIO',
  CHUNKED_AUDIO: 'CHUNKED_AUDIO',
  USER_BACKUP_AUDIO: 'USER_BACKUP_AUDIO',
  WEBSOCKET_AUDIO: 'WEBSOCKET_AUDIO',
  RAW_TRANSCRIPT_METADATA: 'RAW_TRANSCRIPT_METADATA',
  CHART_PDF: 'CHART_PDF',
  SUPERBILL_PDF: 'SUPERBILL_PDF',
  TRANSCODED_AUDIO_FILE: 'TRANSCODED_AUDIO_FILE',
} as const satisfies MatchingRecord<AppointmentFileTypesEnum>;

export const appointmentFileTypesSchema = z.nativeEnum(
  AppointmentFileTypesLookup,
);
